import React from "react";
import { HStack, Text } from "@chakra-ui/react";

import { payoutTotals } from "../utils/payoutTotals";

const COLORS = {
  exact: "green.600",
  over: "red.500",
  under: "orange.500",
  unknown: "gray.600",
};

/**
 * The running total of a payout table, against the pot.
 *
 * Over is red because it is refused on save. Under is amber and merely
 * reported: allocating less than the pot holds is allowed, so this says how
 * much is spare rather than implying the table is unfinished.
 *
 * One component for all six games, so the arithmetic and the wording cannot
 * drift between them — it used to be copied into five pages verbatim.
 */
export default function PayoutTotalLine({ amounts, pot }) {
  const { total, diff, state } = payoutTotals(amounts, pot);
  const spare = diff == null ? 0 : Math.abs(diff);

  return (
    <HStack justify="flex-end">
      <Text fontSize="sm" color={COLORS[state]} fontWeight="semibold">
        Allocated: ${total.toFixed(2)}
        {state === "over" && (
          <Text as="span" color="gray.500" fontWeight="normal">
            {` (+$${spare.toFixed(2)} over the pot)`}
          </Text>
        )}
        {state === "under" && (
          <Text as="span" color="gray.500" fontWeight="normal">
            {` ($${spare.toFixed(2)} unallocated)`}
          </Text>
        )}
        {state === "exact" && " ✓"}
      </Text>
    </HStack>
  );
}
